import styled from 'styled-components';
import { BandsList } from '@widgets/GenericBookings/components/AttendeesSelector/components/Band/styles';
export const Close = styled.button `
  appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
  display: flex;
  background-color: transparent;
  border: none;
  padding: 0;
  position: absolute;
  top: var(--modal-close-position-y);
  right: var(--modal-close-position-x);

  svg {
    pointer-events: none;
    width: var(--modal-close-size);
    height: var(--modal-close-size);
    fill: var(--modal-close-fill);
  }
`;
export const Inner = styled.div `
  padding: 2rem;
  width: calc(100% - 4rem);
  position: relative;
  max-height: calc(100% - 4rem);
  background-color: white;
  color: var(--primary-darker);
  border-radius: var(--border-radius-md);
  max-width: 42rem;
  
  #fitness-page & { 
    &, p, h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {
      color: var(--navy-darker);
    }
  }

  & > svg {
    fill: var(--primary-darker);
  }  
  
  h1,h2,h3,h4,h5,h6 {
    color: inherit;
    font-family: var(--heading-font);
  }
  
  p{
    color: inherit;
    font-family: var(--body-font);
  }
  
  ${BandsList} + button.btn.btn--primary {
    margin-top: 2rem;
  }
`;
export const Backdrop = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: var(--modal-background-gradient);
  backdrop-filter: var(--modal-background-blur);
  background-color: var(--modal-background-color);
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export default {
    Backdrop,
    Close,
    Inner,
};
